module.exports = __webpack_public_path__ + "img/search_null.a46a9d96.svg";